/* eslint-disable */
// This code is autogenerated using @harnessio/oats-cli.
// Please do not modify this code directly.
import type { AssetRating } from '../schemas/AssetRating';
import type { PatchedAssetRating } from '../schemas/PatchedAssetRating';
import { fetcher, FetcherOptions } from './fetcher';

export interface AssetsAssetRatingPartialUpdateAPIPathParams {
  id: string;
}

export type AssetsAssetRatingPartialUpdateRequestBody = PatchedAssetRating;

export type AssetsAssetRatingPartialUpdateOkResponse = AssetRating;

export type AssetsAssetRatingPartialUpdateErrorResponse = unknown;

export interface AssetsAssetRatingPartialUpdateProps
  extends AssetsAssetRatingPartialUpdateAPIPathParams,
    Omit<
      FetcherOptions<unknown, AssetsAssetRatingPartialUpdateRequestBody>,
      'url'
    > {
  body: AssetsAssetRatingPartialUpdateRequestBody;
}

export function assetsAssetRatingPartialUpdate(
  props: AssetsAssetRatingPartialUpdateProps
): Promise<AssetsAssetRatingPartialUpdateOkResponse> {
  return fetcher<
    AssetsAssetRatingPartialUpdateOkResponse,
    unknown,
    AssetsAssetRatingPartialUpdateRequestBody
  >({
    url: `/assets/asset-rating/${props.id}/`,
    method: 'PATCH',
    ...props
  });
}
